// extracted by mini-css-extract-plugin
export var centered = "_g-6";
export var flexible = "_g-5";
export var footer = "_g-k";
export var footerBorder = "_g-l";
export var header = "_g-c";
export var headerBorder = "_g-d";
export var headerDefault = "_g-g";
export var headerMedium = "_g-h";
export var headerPadding = "_g-e";
export var iconAndTitle = "_g-f";
export var large = "_g-4";
export var largePadding = "_g-a";
export var medium = "_g-3";
export var mediumPadding = "_g-9";
export var modal = "_g-0";
export var modalContainer = "_g-b";
export var noPadding = "_g-7";
export var skinny = "_g-1";
export var small = "_g-2";
export var smallPadding = "_g-8";
export var subtitle = "_g-j";
export var title = "_g-i";